import { Role } from '.';

export const demoData: Role[] = [
  {
    id: '557812805546541066',
    name: 'a cute role ♡',
    color: 0xd19494,
    permissions: '0',
    safety: 0,
    managed: false,
    position: 0,
  },
  {
    id: '557812901717737472',
    name: 'a vanity role ♡',
    color: 0xd1d194,
    permissions: '0',
    safety: 0,
    managed: false,
    position: 0,
  },
  {
    id: '557812915386843170',
    name: 'a brave role ♡',
    color: 0x94d194,
    permissions: '0',
    safety: 0,
    managed: false,
    position: 0,
  },
  {
    id: '557824893241131029',
    name: 'a proud role ♡',
    color: 0x94d1d1,
    permissions: '0',
    safety: 0,
    managed: false,
    position: 0,
  },
  {
    id: '557824994269200384',
    name: 'a wonderful role ♡',
    color: 0x9494d1,
    permissions: '0',
    safety: 0,
    managed: false,
    position: 0,
  },
  {
    id: '557825026406088717',
    name: 'a 日本語 role ♡',
    color: 0xd194d1,
    permissions: '0',
    safety: 0,
    managed: false,
    position: 0,
  },
];
